import useModel from "./use-model";
import { getCountryList } from "../hocs/withCountries";

export default () => {
  const model = useModel();

  return getCountryList({ model });
};
